import React, { FC } from 'react';
import Modal, { ModalFooter, Prompt } from '@ingka/modal';
import Button from '@ingka/button';
import { Stack } from '@mui/material';
import { DeleteProjectConfirmationPromptProps } from './DeleteProjectConfirmationPromptProps';
import useTranslation from '../../hooks/useTranslation';

const DeleteProjectConfirmationPrompt: FC<
  DeleteProjectConfirmationPromptProps
> = ({ isVisible, onClose, onCancel, onAccept }) => {
  const t = useTranslation();
  return (
    <Modal handleCloseBtn={onClose} visible={isVisible}>
      <Prompt
        aria-label="header-for-a-delete-project-modal"
        className="example-prompt-override"
        header={null}
        titleId={'delete-project-modal-title'}
        footer={
          <ModalFooter>
            <Stack direction={'row'} spacing={2}>
              <Button
                text={t('common.cancel')}
                type="secondary"
                onClick={onCancel}
              />
              <Button
                text={t('ppm.actions.deleteProject')}
                type="danger"
                onClick={onAccept}
              />
            </Stack>
          </ModalFooter>
        }
        title={t('ppm.actions.deleteProject')}
      >
        <p>{t('projects.deleteProjectDescription')}</p>
      </Prompt>
    </Modal>
  );
};

export default DeleteProjectConfirmationPrompt;
